// LayerSeek asset URLs (hosted on Emergent CDN)
export const layerSeekAssets = {
  floorPlan: '/floor_plan.svg',
  features: [
    {
      id: 'miro',
      title: 'Miro Board Integration',
      label: 'Collaboration',
      image: 'https://customer-assets.emergentagent.com/job_6f758192-ab9f-49b2-b18c-e8fbed640b66/artifacts/ipv2pr3u_miro%20integration.gif',
    },
    {
      id: 'avatars',
      title: 'Customizable Avatars',
      label: 'Personalization',
      image: 'https://customer-assets.emergentagent.com/job_6f758192-ab9f-49b2-b18c-e8fbed640b66/artifacts/13e4o76y_Customizable%20User%20Profile.svg',
    },
    {
      id: 'video',
      title: '1080p HD Video',
      label: 'Quality',
      image: 'https://customer-assets.emergentagent.com/job_6f758192-ab9f-49b2-b18c-e8fbed640b66/artifacts/qsghybas_High%20quality%20video%20and%20audio.png',
    },
    {
      id: 'mainstage',
      title: 'Live Mainstage',
      label: 'Presentations',
      image: 'https://customer-assets.emergentagent.com/job_6f758192-ab9f-49b2-b18c-e8fbed640b66/artifacts/a2bfcfc5_presentation%20mode.gif',
    },
    {
      id: 'chat',
      title: 'Multi-level Chat',
      label: 'Communication',
      image: 'https://customer-assets.emergentagent.com/job_6f758192-ab9f-49b2-b18c-e8fbed640b66/artifacts/det5dccm_chatbox.png',
    },
    {
      id: 'analytics',
      title: 'Sponsor Analytics',
      label: 'ROI',
      image: 'https://customer-assets.emergentagent.com/job_6f758192-ab9f-49b2-b18c-e8fbed640b66/artifacts/k110d1ev_Analytics.png',
    },
  ],
};
